import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../../../common/SvgIcon';

const Document = ({ image, remove }) => (
  <button
    className="chat-messenger_image-wrapper -inverted"
    title={image.filename}
    onClick={() => remove()}
  >
    <div className="chat-messenger_image-placeholder">
      <SvgIcon icon="icon-document" />
      <div className="chat-messenger_image-filename">{image.filename}</div>
    </div>
  </button>
);

Document.propTypes = {
  image: PropTypes.shape({}).isRequired,
  remove: PropTypes.func.isRequired,
};

export default Document;



// WEBPACK FOOTER //
// ./app/javascript/common/components/NewMessageImage/Document.js